import { Col, Spin, Upload, UploadProps } from 'antd';
import ProductApi from 'apis/ProductApi';
import { AddImage } from 'assets/svg';
import Button from 'components/Button';
import { IProduct, IProductImage } from 'interface/product.interface';
import { useMutation } from 'react-query';
import { Image } from 'antd';
import { openNotificationWithIcon } from 'utils/notification';
import { useEffect, useState } from 'react';

interface IProps {
  product?: IProduct;
  images?: IProductImage[];
  onAddNewImage?: (images: IProductImage) => void;
  onDeleteImage?: () => void;
}
export default function ListImage(props: IProps): JSX.Element {
  const { product, images, onAddNewImage, onDeleteImage } = props;
  const [files, setFiles] = useState<any[]>([]);
  const [isUploading, setIsUploading] = useState<any>(false);

  const groupedImages: {
    [key: string]: { date: Date; images: IProductImage[] };
  } = {};
  if (images) {
    images.forEach((image) => {
      const date = new Date(image.created_at);
      const monthYear = `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()}`;
      if (!groupedImages[monthYear]) {
        groupedImages[monthYear] = {
          date: date,
          images: [],
        };
      }
      groupedImages[monthYear].images.push(image);
    });
  }
  const groupedImagesList = Object.values(groupedImages);

  async function handleFileChange(info: UploadProps) {
    const newfiles = info.fileList.map((file: any) => {
      return file.originFileObj;
    });
    setFiles(newfiles);
    setIsUploading(true);
  }

  async function uploadImages() {
    for (let i = 0; i < files.length; i++) {
      await ProductApi.uploadImage({
        product_code: product!.product_code,
        files: [files[i]],
      })
        .then((data) => {
          const image: IProductImage = {
            id: data.data.id,
            product_id: data.data.product_id,
            image_path: data.data.image_path,
            active: data.data.active,
            index: data.data.index,
            created_at: new Date(data.data.created_at),
          };
          if (onAddNewImage) {
            onAddNewImage(image);
          }
        })
        .catch((err) => {
          openNotificationWithIcon('error', err.toString());
        });
    }
    setIsUploading(false);
    setFiles([]);
  }

  const { mutate: uploadImage, isLoading } = useMutation(
    ProductApi.uploadImage,
    {
      onSuccess: (data) => {
        const image: IProductImage = {
          id: data.data.id,
          product_id: data.data.product_id,
          image_path: data.data.image_path,
          active: data.data.active,
          index: data.data.index,
          created_at: new Date(data.data.created_at),
        };
        if (onAddNewImage) {
          onAddNewImage(image);
        }
      },
      onError: (error: any) => {
        console.log(error);
      },
    }
  );

  const { mutate: deleteImage, isLoading: isDeleteLoading } = useMutation(
    ProductApi.deleteImage,
    {
      onSuccess: (data) => {
        if (onDeleteImage) {
          onDeleteImage();
        }
      },
      onError: (error: any) => {
        console.log(error);
      },
    }
  );

  useEffect(() => {
    if (isUploading) {
      uploadImages();
    }
  }, [isUploading]);

  return (
    <Spin
      tip="Loading..."
      spinning={isLoading || isDeleteLoading || isUploading}
    >
      <Col className="flex justify-end">
        <Upload
          accept=".jpg,.jpeg,.png"
          onChange={handleFileChange}
          beforeUpload={() => false}
          fileList={[]}
          multiple
          showUploadList={false}
        >
          <Button>
            <AddImage />
            Cập nhật hình ảnh
          </Button>
        </Upload>
      </Col>

      {groupedImagesList.map((group, groupIndex) => (
        <div key={groupIndex} className="mb-8">
          <div className="text-sm font-bold mb-3 text-primary-50">
            {group.date.getDate()}/{group.date.getMonth()}/
            {group.date.getFullYear()}
          </div>
          <div
            className="flex flex-row"
            style={{ gap: '25px', display: 'flex', flexWrap: 'wrap' }}
          >
            {group.images.map((image, imageIndex) => (
              <div
                key={imageIndex}
                className="flex flex-col items-center"
                style={{ gap: '8px' }}
              >
                <Image
                  className="border border-solid border-neutral-90 rounded-lg mb-4"
                  width={150}
                  height={150}
                  src={image.image_path}
                />
                <a
                  onClick={() => {
                    deleteImage(image.id);
                  }}
                  style={{ color: '#DC362E', fontSize: '12px' }}
                >
                  Xóa
                </a>
              </div>
            ))}
          </div>
        </div>
      ))}
    </Spin>
  );
}
